module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/km-4c4fa2a75b7c9360ac5f343b19ad4c9e.svg";